import { graphql } from 'gatsby'
import React from 'react'

import SupportPage from '../containers/Support/SupportPage'

const Support = ({ data }) => {
  return <SupportPage {...data.portal} />
}

export default Support

export const query = graphql`
  query SupportQuery ($firebaseId: String) {
    portal(firebaseId: {eq: $firebaseId}) {
      ...PartialPortalData
      ...SupportData
    }
  }
`
